import { tss } from 'tss-react/mui';

const useStyles = tss
  .withParams<{
    outlined?: boolean;
  }>()
  .create(({ theme, outlined }) => ({
    stackedBarChart: {
      height: '100%',
      border: outlined ? `2px solid ${theme.vars.palette.divider}` : 'none',
      borderRadius: '4px',
      paddingBottom: outlined ? '0.75rem' : '0'
    }
  }));

export default useStyles;
